import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/providerDisclaimer/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/providerDisclaimer/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/providerDisclaimer/FETCH_FAILURE'

const CREATE_REQUEST = 'realbase/providerDisclaimer/CREATE_REQUEST'
const CREATE_SUCCESS = 'realbase/providerDisclaimer/CREATE_SUCCESS'
const CREATE_FAILURE = 'realbase/providerDisclaimer/CREATE_FAILURE'

const UPDATE_REQUEST = 'realbase/providerDisclaimer/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realbase/providerDisclaimer/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realbase/providerDisclaimer/UPDATE_FAILURE'

const DELETE_REQUEST = 'realbase/providerDisclaimer/DELETE_REQUEST'
const DELETE_SUCCESS = 'realbase/providerDisclaimer/DELETE_SUCCESS'
const DELETE_FAILURE = 'realbase/providerDisclaimer/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loadedForKeys: [],
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadProviderDisclaimers(options){
  const { entityKey } = options || {}

  return (dispatch, getState) => {
    const state = getState()
    const loadedForKeys = [...state.providerDisclaimers.loadedForKeys]

    if (entityKey && !loadedForKeys.includes(entityKey)){
      loadedForKeys.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/provider_disclaimers.json', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDER_DISCLAIMER_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createProviderDisclaimer(providerDisclaimer, options){
  const config = {
    method: 'POST',
    data: JSON.stringify({
      provider_disclaimer: providerDisclaimer,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/provider_disclaimers.json', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDER_DISCLAIMER)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateProviderDisclaimer(providerDisclaimer, options){
  const config = {
    method: 'PUT',
    data: JSON.stringify({
      provider_disclaimer: providerDisclaimer,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/provider_disclaimers/${providerDisclaimer.id}.json`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDER_DISCLAIMER)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteProviderDisclaimer(providerDisclaimer){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/provider_disclaimers/${providerDisclaimer.id}.json`, {}, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.PROVIDER_DISCLAIMER)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
